export default "__VITE_ASSET__cebde266__"